
/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertTitle, Typography } from '@mui/material';

import { FC } from 'react';

/*
 * ----------------------------------------------------------------------------------
 * Imports - Internal
 * ----------------------------------------------------------------------------------
 */

import { PatientStateType } from "../../../api/dtos";


export interface IPatientSummaryAlertsProps {
    patientState: PatientStateType | undefined;
    patientValid: boolean;
    patientAllocationIneligible: boolean;
}

const PatientSummaryAlerts: FC<IPatientSummaryAlertsProps> = ({
    patientState,
    patientValid,
    patientAllocationIneligible
}) => {
    return (
        <>
            {
                patientState === PatientStateType.Screening && patientValid && (
                    <Alert
                        icon={<FontAwesomeIcon icon={faInfoCircle as IconDefinition} fixedWidth />}
                        severity="info"
                        sx={{mt: 2}}
                    >
                        <AlertTitle>
                            <strong>
                                Note
                            </strong>
                        </AlertTitle>
                        <Typography>
                            Screening form has been completed. Please click COMPLETE SCREENING to start the consent process. 
                        </Typography>
                    </Alert>
                )
            }
            {
                patientState === PatientStateType.Consent && patientValid && (
                    <Alert
                        icon={<FontAwesomeIcon icon={faInfoCircle as IconDefinition} fixedWidth />}
                        severity="info"
                        sx={{mt: 2}}
                    >
                        <AlertTitle>
                            <strong>
                                Note
                            </strong>
                        </AlertTitle>
                        <Typography>
                            Main consent form has been completed completed. Please click COMPLETE CONSENT to start the registration. 
                        </Typography>
                    </Alert>
                )
            }
            {
                patientState === PatientStateType.Registration && patientValid && (
                    <Alert
                        icon={<FontAwesomeIcon icon={faInfoCircle as IconDefinition} fixedWidth />}
                        severity="info"
                        sx={{mt: 2}}
                    >
                        <AlertTitle>
                            <strong>
                                Note
                            </strong>
                        </AlertTitle>
                        <Typography>
                            Registration forms have been completed. Please click REGISTER to start the radiologist review. 
                        </Typography>
                    </Alert>
                )
            }
            {
                patientState === PatientStateType.RadiologistReview && (
                    <Alert
                        icon={<FontAwesomeIcon icon={faInfoCircle as IconDefinition} fixedWidth />}
                        severity="info"
                        sx={{mt: 2}}
                    >
                        <AlertTitle>
                            <strong>
                                Note
                            </strong>
                        </AlertTitle>
                        <Typography>
                            Radiologist Report must be completed to start the allocation.
                        </Typography>
                    </Alert>
                )
            }
            {
                patientState === PatientStateType.Allocation && patientValid && !patientAllocationIneligible && (
                    <Alert
                        icon={<FontAwesomeIcon icon={faInfoCircle as IconDefinition} fixedWidth />}
                        severity="info"
                        sx={{mt: 2}}
                    >
                        <AlertTitle>
                            <strong>
                                Note
                            </strong>
                        </AlertTitle>
                        <Typography>
                            Allocation forms have been completed. Please click ALLOCATE to allocate patient treatment arm. 
                        </Typography>
                    </Alert>
                )
            }
        </>
    )
}

export default PatientSummaryAlerts;